import { render, staticRenderFns } from "./ListNominaFiscal.vue?vue&type=template&id=1fdd41b0&"
import script from "./ListNominaFiscal.vue?vue&type=script&lang=js&"
export * from "./ListNominaFiscal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports